import { render, staticRenderFns } from "./applyRiskDialog.vue?vue&type=template&id=510ba68a&scoped=true"
import script from "./applyRiskDialog.vue?vue&type=script&lang=js"
export * from "./applyRiskDialog.vue?vue&type=script&lang=js"
import style0 from "./applyRiskDialog.vue?vue&type=style&index=0&id=510ba68a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510ba68a",
  null
  
)

export default component.exports